export const THEME_TOGGLER = "THEME_TOGGLER"

export const themeToggler = (update) => ({
    type: THEME_TOGGLER,
    payload: update
})